import styled from "@emotion/styled";

export const TabPanelHeader = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
